// extracted by mini-css-extract-plugin
module.exports = {"block":"_4611","title":"_6063","list":"_4650","item":"_8802","cover":"_15762","name":"_6958","price":"_18568","current":"_3526","cost":"_5382"};